import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MsalGuard} from "@azure/msal-angular";

const routes: Routes = [
  {
  path: "",
  canActivate: [MsalGuard],
  loadChildren: () =>
    import("./ui/ui.module").then((m) => {
      return m.UiModule;
    }),
},
];


@NgModule({
  imports: [RouterModule.forRoot(routes,  { onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
